import {Component, OnInit} from '@angular/core';
import {ApiService} from '../api.service';
import {Router} from '@angular/router';
import {HandlerService} from '../handler.service';
import {AuthService} from '../auth.service';
import {AppComponent} from '../app.component';
import {DomSanitizer} from '@angular/platform-browser';
import {Platform} from '@angular/cdk/platform';
import * as sha512 from 'js-sha512';

@Component({
    selector: 'app-vendor-details',
    templateUrl: './vendor-details.component.html',
    styleUrls: ['./vendor-details.component.scss'],
})
export class VendorDetailsComponent {
    pass;
    hide;
    numCd = "+91";
    numb;
    fName;
    lName;
    email;
    org;
    loader = false;
    header;
    pic;
    passwordPolicy: boolean = false;
    maxlength = '9';
    orgcode;
    Password;
    code;
    gender: any;
    genderName;
    otpverification: boolean = true;
    phone;
    check: boolean = false;
    otp;
    mobileVerify: any = {};
    userId;
    id;
    VendoruserId;

    constructor(public service: ApiService,
                public router: Router,
                public handler: HandlerService,
                public auth: AuthService,
                public app: AppComponent,
                public santinzer: DomSanitizer,
                public platform: Platform) {
    }

    IonViewWillEnter() {

    }

    register() {
        var x = JSON.parse(sessionStorage.getItem('category'))
        var y: any = []
        x.map(res => {
            y.push(res.id)
        })
        this.loader = true;
        if (this.fName && this.numb != "") {
            if (!this.loader && this.fName && this.lName && this.numb && this.org && this.email)
                if (this.fName) {
                    this.fName = this.fName.toUpperCase();
                }
            if (this.lName) {
                this.lName = this.lName.toUpperCase();
            }
            if (this.org) {
                this.org = this.org.toUpperCase();
            }
            var post = {
                password: window.btoa(this.Password),
                contactNbrMob: this.numCd + this.numb,
                firstName: this.fName,
                lastName: 'k',
                userType: 1,
                orgCode: this.code,
                category: y,
                appId: 14,
                roles: ['SC']

            }
            this.loader = true;
            this.service.register(post).subscribe(
                (res: any) => {
                    localStorage.setItem('organizationId', '790');
                    localStorage.setItem('vendoruserId', res.userId);
                    window['mock'] = res;
                    // this.router.navigate(['acvalidate'])
                    this.loader = false;
                    this.handler.res('Registered Successfully !!')
                    this.vendorsendOtp()
                    // this.otpverification=false;
                    this.router.navigate(["vendor-login"]);
                },
                err => {
                    this.handler.err(err);
                    this.loader = false;
                })
        } else {
            this.handler.res("Please Enter The Required Fields");
            this.loader = false;
        }
    }

    setOrg() {
        this.org = localStorage.getItem('orgName');
        localStorage.removeItem('orgName')
    }

    openPasswordPolicy() {
        this.passwordPolicy = true;
    }

    closepwdpolicy() {
        this.passwordPolicy = false;
    }


    vendorsendOtp() {
        this.loader = true;
        // this.vendoruser=true;
        this.numb = localStorage.setItem('vendorMobile', this.numb);
        this.VendoruserId = localStorage.getItem('vendoruserId');
        this.service.sendMobileOtp(this.VendoruserId, this.numb).subscribe(res => {
            this.check = true;
            this.loader = false;
            this.handler.res('OTP Sent Successfully');

        }, err => {
            this.handler.err(err);
            this.check = true;
            this.loader = false;
        })
        this.router.navigate(['/login']);
    }


    back() {
        this.router.navigate(['/vendorCategory'])
    }

    next() {
        this.router.navigate(['/vendoraddress'])
    }

    IonViewWillLeave() {
        this.fName = '';
    }
}
